import { render, staticRenderFns } from "./fpcListnew.vue?vue&type=template&id=a72ee536&scoped=true&"
import script from "./fpcListnew.vue?vue&type=script&lang=js&"
export * from "./fpcListnew.vue?vue&type=script&lang=js&"
import style0 from "./fpcListnew.vue?vue&type=style&index=0&id=a72ee536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72ee536",
  null
  
)

export default component.exports